import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

const API_PYTHON_URL = process.env.REACT_APP_API_URL_PYTHON || "http://localhost:5001";

export default function NearbyPlacesModal({ open, lat, lng, name, onClose }) {
    const { i18n, t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [places, setPlaces] = useState([]);
    const radius_km = 3;

    useEffect(() => {
        if (!open || lat == null || lng == null) return;
        setLoading(true);
        setError(null);
        setPlaces([]);
        fetch(`${API_PYTHON_URL}/api/outdoor-places`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ lat, lon: lng, radius_km, lang: i18n.language })
        })
            .then(r => { if (!r.ok) throw new Error(r.statusText); return r.json(); })
            .then(data => setPlaces(data.places || []))
            .catch(e => setError(e.message))
            .finally(() => setLoading(false));
    }, [open, lat, lng, i18n.language]); // ← aggiunto i18n.language

    if (!open) return null;

    return (
        <div className="ai-modal-overlay" style={{
            position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
            background: "rgba(0,0,0,0.35)", zIndex: 9999,
            display: "flex", alignItems: "center", justifyContent: "center"
        }} onClick={onClose}>
            <div style={{
                background: "white", borderRadius: 12, padding: 24,
                minWidth: 320, maxWidth: 420,
                boxShadow: "0 4px 24px rgba(0,0,0,0.18)", position: "relative"
            }} onClick={e => e.stopPropagation()}>
                <button onClick={onClose} style={{
                    position: "absolute", top: 10, right: 10,
                    background: "none", border: "none", fontSize: 22, cursor: "pointer"
                }}>×</button>

                <h2 style={{ marginTop: 0, fontSize: 20, color: "#1976d2" }}>
                    {t('luoghi_outdoor')}
                </h2>
                <p style={{ fontSize: 13, color: "#555", marginBottom: 16 }}>
                    {t('risultati_entro')} {radius_km} {t('da_questo_punto')}
                </p>

                <div style={{ minHeight: 60 }}>
                    {loading && (
                        <div style={{ textAlign: "center", color: "#666" }}>
                            <div style={{
                                display: "inline-block", width: 20, height: 20,
                                border: "2px solid #f3f3f3",
                                borderTop: "2px solid #4CAF50",
                                borderRadius: "50%",
                                animation: "spin 1s linear infinite"
                            }}></div>
                            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                            <p style={{ marginTop: 10, fontSize: 12 }}>{t('loading')}</p>
                        </div>
                    )}
                    {error && (
                        <div style={{ color: "red", textAlign: "center" }}>
                            {t('error_prefix')}: {error}
                        </div>
                    )}
                    {!loading && !error && (
                        places.length === 0
                            ? <p style={{ color: "#888" }}>{t('no_results')}</p>
                            : <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
                                {places.map(place => (
                                    <div key={place.url} style={{
                                        marginBottom: 18, paddingBottom: 12,
                                        borderBottom: "1px solid #eee"
                                    }}>
                                        <a href={place.url} target="_blank" rel="noopener noreferrer"
                                            style={{ fontSize: 15, fontWeight: 600, color: "#1976d2", textDecoration: "none" }}>
                                            {place.title}
                                        </a>
                                        <p style={{ fontSize: 12, color: "#333", margin: "6px 0 0 0" }}>
                                            {place.snippet || ""}
                                        </p>
                                        <a href={place.url} target="_blank" rel="noopener noreferrer"
                                            style={{ fontSize: 11, color: "#888", wordBreak: "break-all" }}>
                                            {place.url}
                                        </a>
                                    </div>
                                ))}
                            </div>
                    )}
                </div>
            </div>
        </div>
    );
}